<template>
  <AuthShell
    :title="$t('forgotPassword.heroTitle')"
    :subtitle="$t('forgotPassword.heroSubtitle')"
  >
    <div class="space-y-6">
      <div>
        <p class="text-sm uppercase tracking-[0.3em] text-steel-400">{{ $t('forgotPassword.eyebrow') }}</p>
        <h2 class="mt-3 font-display text-2xl font-semibold text-white">{{ $t('forgotPassword.title') }}</h2>
      </div>

      <form class="space-y-5" @submit.prevent="sendResetLink">
        <label class="block text-sm text-steel-200">
          {{ $t('forgotPassword.email') }}
          <input
            v-model.trim="email"
            type="email"
            placeholder="driver@drvn.co"
            class="mt-2 w-full rounded-2xl border border-white/10 bg-midnight-900/60 px-4 py-3 text-base text-white placeholder:text-steel-400 focus:border-neon-400/70 focus:outline-none focus:ring-2 focus:ring-neon-400/30"
            autocomplete="email"
          />
        </label>

        <button
          type="submit"
          class="w-full rounded-2xl bg-white px-4 py-3 text-sm font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-400 disabled:cursor-not-allowed disabled:opacity-70"
          :disabled="isLoading"
        >
          {{ isLoading ? $t('forgotPassword.submitting') : $t('forgotPassword.submit') }}
        </button>
      </form>

      <p v-if="statusMessage" class="rounded-2xl border border-neon-400/30 bg-neon-400/10 px-4 py-3 text-sm text-neon-100">
        {{ statusMessage }}
      </p>

      <p v-if="errorMessage" class="rounded-2xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-100">
        {{ errorMessage }}
      </p>

      <p class="text-center text-xs text-steel-400">
        {{ $t('forgotPassword.remembered') }}
        <router-link class="text-neon-400 hover:text-neon-500" to="/login">{{ $t('forgotPassword.backToSignIn') }}</router-link>
      </p>
    </div>
  </AuthShell>
</template>

<script>
import AuthShell from '@/components/auth/AuthShell.vue'
import { supabase } from '@/lib/supabase'

export default {
  name: 'ForgotPasswordView',
  components: {
    AuthShell,
  },
  data() {
    return {
      email: '',
      isLoading: false,
      statusMessage: '',
      errorMessage: '',
    }
  },
  methods: {
    async sendResetLink() {
      if (!this.email) {
        this.errorMessage = this.$t('forgotPassword.missingEmail')
        return
      }

      this.isLoading = true
      this.statusMessage = ''
      this.errorMessage = ''

      const redirectTo = `${window.location.origin}/reset-password`
      const { error } = await supabase.auth.resetPasswordForEmail(this.email, { redirectTo })

      this.isLoading = false

      if (error) {
        this.errorMessage = error.message || this.$t('forgotPassword.sendError')
        return
      }

      this.statusMessage = this.$t('forgotPassword.sent')
    },
  },
}
</script>
